import React from 'react';
import { FormattedMessage } from 'react-intl';
import { OptionFormTypes } from '../../../../../services/filtering/filter-form-render-service/option-form-types';
import { renderFormBasedOnType } from '../../../../../services/filtering/filter-form-render-service/';
import messages from '../messages';

export default {
  id: 'shipFrom',
  displayName: <FormattedMessage {...messages.shipFrom} />,
  type: OptionFormTypes.TYPE_ORDER_COLLECTION_FILTER,
  filterValue: 'ShipFromId',
  expectsArgumentAsArray: true,
  allowsMultipleSelection: true,
  render: (criteriaInformations, existingFiltersHelpers) => {
    return renderFormBasedOnType(OptionFormTypes.TYPE_CHECKLIST, criteriaInformations, existingFiltersHelpers);
  },
  shouldHideActionButtons: true,
};
